<div class="p-6">
    <p class="titre2">{{ 'TAGS_MANAGEMENT.CONFIRM_DELETION' | translate }}</p>
    <p class="mb-6">{{ 'TAGS_MANAGEMENT.DELETE_TAG_CONFIRMATION' | translate }}</p>
    <div class="flex justify-end gap-6">
        <button (click)="annuler()" class="btn-secondary-novo">
            {{ 'TAGS_MANAGEMENT.BUTTON_CANCEL' | translate }}
        </button>
        <button (click)="confirmerSuppression()" class="btn-primary-novo">
            {{ 'TAGS_MANAGEMENT.BUTTON_CONFIRM' | translate }}
        </button>
    </div>
</div>
